// extracted by mini-css-extract-plugin
export default {"mainContainer":"OfflineOnboarding_mainContainer__vY-BQ","generateButton":"OfflineOnboarding_generateButton__T3VIm"};